/* unplugin-vue-components disabled */import { render } from "./vacation.vue?vue&type=template&id=05e6d589&scoped=true"
import script from "./vacation.vue?vue&type=script&lang=js"
export * from "./vacation.vue?vue&type=script&lang=js"

import "./vacation.vue?vue&type=style&index=0&id=05e6d589&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e6d589"]])

export default __exports__